import { Editor } from '@tiptap/react';
import { marks } from './marks';
import { nodes } from './nodes';

interface Props {
  editor: Editor;
  children?: Record<string, any>;
}

export const Renderer = ({ children, editor }: Props) => {
  if (!children) {
    return null;
  }
  const [mark, ...rest] = children.marks ?? [];
  if (mark) {
    const C = mark.type && marks[mark.type];
    if (!C)
      return (
        <Renderer editor={editor}>{{ ...children, marks: rest }}</Renderer>
      );
    return (
      <C node={mark} editor={editor}>
        <Renderer editor={editor}>{{ ...children, marks: rest }}</Renderer>
      </C>
    );
  }
  const C = children.type && nodes[children.type];
  if ('content' in children && children.content) {
    if (!C) {
      return (
        <>
          {(children.content as any[]).map((child, i) => (
            <Renderer key={i} editor={editor}>
              {child}
            </Renderer>
          ))}
        </>
      );
    }
    return (
      <C node={children} editor={editor}>
        {(children?.content as any[]).map((child, i) => (
          <Renderer key={i} editor={editor}>
            {child}
          </Renderer>
        ))}
      </C>
    );
  }
  if (!C) {
    return children.text;
  }

  return (
    <C editor={editor} node={children}>
      {children.text}
    </C>
  );
};
